import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Swal from 'sweetalert2';
import { patchCcoUpdate } from '../../../api/ccoApi';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AttachmentUploadModal({
  form,
  setForm,
  setLoadingAttachment,
  uploadAttachmentModal,
  setUploadAttachmentModal,
}) {
  // const [formRequest, setFormRequest] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  // const [imagePreviews, setImagePreviews] = useState([]);
  // const [uploadProgress, setUploadProgress] = useState({});

  const handleClose = () => {
    setUploadAttachmentModal(false);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);

    // const newImagePreviews = files.map((file) => URL.createObjectURL(file));
    // setImagePreviews((prevPreviews) => [...prevPreviews, ...newImagePreviews]);
  };

  const converFiletoBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });

  const handleUploadAttachment = async () => {
    const filePathsPromises = [];
    selectedFiles.forEach((file) => {
      filePathsPromises.push(converFiletoBase64(file));
    });
    const filePaths = await Promise.all(filePathsPromises);
    const mappedFiles = filePaths.map((base64File, i) => ({
      id: null,
      file_name: selectedFiles[i].name,
      file: base64File,
    }));

    setForm({ ...form, attachments_to_upload: mappedFiles });
    setLoadingAttachment(false);
    handleClose();
    toast.dismiss();

    // const request = {
    //   id: accountData?.id,
    //   attachments: mappedFiles,
    // };
    // const response = await patchCcoUpdate(request);
    // const { code, data } = response.data;

    // if (response.data.response?.code === '500') {
    //   Swal.fire({
    //     title: 'Attachment Upload',
    //     html: response.data.response?.result.join('<br />'),
    //     icon: 'warning',
    //   });
    //   setSelectedFiles([]);
    //   toast.dismiss();
    //   return;
    // }

    // if (code === '00004') {
    //   setLoadingAttachment(true);
    //   setForm({ ...form, attachments: data.attachments });
    //   setSelectedFiles([]);
    //   handleClose();
    //   toast.dismiss();
    //   toast.success('Successfully updated attachment');
    // }
    //
  };

  return (
    <BootstrapDialog
      aria-labelledby='customized-dialog-title'
      open={uploadAttachmentModal}
      maxWidth='lg'
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
        Upload Attachment
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={() => handleClose()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <TextField
          type='file'
          id='file'
          name='file'
          onChange={(e) => handleFileChange(e)}
          size='small'
          fullWidth
          style={{ marginTop: '10px' }}
          inputProps={{
            multiple: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleUploadAttachment()}
          variant='contained'
          disabled={selectedFiles.length === 0}
          startIcon={<CloudUploadIcon />}
        >
          Upload
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}

AttachmentUploadModal.defaultProps = {
  accountData: null,
  setAccountData: () => {},
  setLoadingAttachment: () => {},
  uploadAttachmentModal: false,
  setUploadAttachmentModal: () => {},
};

AttachmentUploadModal.propTypes = {
  accountData: PropTypes.object?.isRequired,
  setAccountData: PropTypes.func,
  setLoadingAttachment: PropTypes.func,
  uploadAttachmentModal: PropTypes.bool,
  setUploadAttachmentModal: PropTypes.func,
};
